import React from 'react';
import ContentLoader from 'react-content-loader';

const LoaderMB = () => {
  return (
    <ContentLoader
      speed={2}
      width={500}
      height={223}
      viewBox={`0 0 500 223`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb">
      <>

        <rect x="20" y="25" rx="3" ry="3" width="52" height="10" />
        <rect x="20" y="44" rx="3" ry="3" width="260" height="38" />
        <rect x="290" y="44" rx="3" ry="3" width="110" height="34" />

        <rect x="20" y="132" rx="3" ry="3" width="30" height="10" />
        <rect x="20" y="151" rx="3" ry="3" width="160" height="34" />

      </>
    </ContentLoader>
  );
};

export default LoaderMB;
